export type TDealRentVersionState = EDealRentVersion | null;

export enum EDealRentVersion {
  /** Сделка v1 **/
  V1 = 'v1',
  /** Сделка v2 **/
  V2 = 'v2',
}
